import step3Image from '@/assets/tourguide/00000/step3.png'

export default [
  {
    target: 'header .v-toolbar__content',
    title: 'ようこそ、OKASHOPへ！',
    hideArrow: true,
    content: `<p>こちらは岡總株式会社が運営するWeb発注サイトです。</p>
<p>「次へ」ボタンをクリックして、ガイドツアーを開始しましょう。</p>`,
  },
  {
    target: '#tour-step1',
    placement: 'top',
    title: 'サイトにログインしましょう',
    content: `<p>ログインIDとパスワードを入力し、「ログイン」ボタンをクリックしてください。</p>`,
  },
  {
    target: '#tour-step1',
    placement: 'bottom',
    hideArrow: true,
    title: '操作をおこなう担当者を選択します',
    content: `<p>ログインが成功すると、担当者を選択するためのポップアップが表示されます。</p>
<p>担当者を選択して、サイトの利用を開始してください。</p><img class="badge-bg" src="${step3Image}" style="width: 100%; height: 235px; margin-top: 20px" />`,
  },
  {
    target: '#tour-step3',
    placement: 'bottom',
    title: 'ログインIDまたはパスワードがわからないときは',
    content: `ログインID･パスワードに関するお問い合わせは、営業担当までご連絡ください。`,
  },
]